export class EnumUtils {
    public static getKeys<T extends { [key: string]: string | number }>(enumeration: T): string[] {
        return Object.keys(enumeration).filter((k: string) => typeof enumeration[k] === 'number');
    }

    public static getValues<T extends { [key: string]: string | number }>(enumeration: T): number[] {
        return this.getKeys(enumeration).map((key: string) => enumeration[key] as number);
    }

    public static getValueByKey<T extends { [key: string]: string | number }>(enumeration: T, key: string): number | undefined {
        return this.getKeys(enumeration).includes(key) ? (enumeration[key] as number) : undefined;
    }
}
